module.exports = __webpack_public_path__ + "static/terna-466a1cdebe9bbc37e2485ae3c0a40b65.jpg";